import { render, staticRenderFns } from "./redeemPrize.vue?vue&type=template&id=29985e35&scoped=true&"
import script from "./redeemPrize.vue?vue&type=script&lang=js&"
export * from "./redeemPrize.vue?vue&type=script&lang=js&"
import style0 from "./redeemPrize.vue?vue&type=style&index=0&id=29985e35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29985e35",
  null
  
)

export default component.exports